import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import { ExplorerOptions } from './ExplorerOptions';
import { PageHeader } from 'components/PageHeader';

export const ExplorerOptionsModal: React.FC<
  ModalScreenProps<ModalScreens.ASEEXPLOREROPTIONS>
> = () => {
  const dispatch = useDispatch();
  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="View Options"
          onPressSaveButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      <ExplorerOptions />
    </Page>
  );
};
